import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { RootState } from "../store";
import { isTokenExpired } from "../helpers";

export const routeRoles: Record<string, string[]> = {
  "/admin-home": ["ROLE_ADMIN", "ROLE_COACH", "ROLE_INSTRUCTOR", "ROLE_RECEPCIONIST"],
  ...Object.fromEntries(["/users", "/clients", "/payments", "/reports", "/coaches", "/configurations", "/classes", "/agreementadmin", "/plans"].map(path => [path, ["ROLE_ADMIN"]])),
  ...Object.fromEntries(["/profile", "/my-trainings", "/my-routines", "/my-classes", "/my-payments"].map(path => [path, ["ROLE_CLIENT"]])),
  ...Object.fromEntries(["/payment-registry", "/client-registry", "/client-plans"].map(path => [path, ["ROLE_ADMIN", "ROLE_COACH", "ROLE_RECEPCIONIST"]])),
  "/trainings": ["ROLE_ADMIN", "ROLE_COACH"],
  "/exercises": ["ROLE_ADMIN", "ROLE_COACH"],
  "/instructor-classes": ["ROLE_INSTRUCTOR"],
};

export const canAccessRoute = (path: string, roles: string[]) =>
  !routeRoles[path] || routeRoles[path].some(role => roles.includes(role));

const ProtectedRoute: React.FC<{ path: string; children: React.ReactElement }> = ({ path, children }) => {
  const user = useSelector((state: RootState) => state.auth.user);
  if (!user || isTokenExpired(user)) return <Navigate to="/login" replace />;
  if (user.conditions === false && path !== "/terms-conditions") return <Navigate to="/terms-conditions" replace />;
  if (user.firstLogin && path !== "/terms-conditions") return <div role="status">Preparando cambio de contrase?a...</div>;
  if (!canAccessRoute(path, user.roles)) return <Navigate to="/unauthorized-page" replace />;
  return children;
};

export default ProtectedRoute;
